module.exports = __webpack_public_path__ + "img/service_img_6.db3a2131.png";